// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/**
 * 创建排班
 * @description 创建一个新的排班记录
 * @param data 包含title、start_date、end_date和details的请求参数
 * @returns Promise<OA.ApiResponse<OA.CreateShiftScheduleResult>>
 */
export async function createShiftSchedule(
  data: OA.CreateShiftScheduleParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.CreateShiftScheduleResult>>('/api/v1/wechat/shift/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 更新排班
 * @description 更新指定的排班记录
 * @param data 包含shift_id、title、start_date、end_date和details的请求参数
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function updateShiftSchedule(
  data: OA.UpdateShiftScheduleParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>('/api/v1/wechat/shift/update', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除排班
 * @description 删除指定的排班记录，系统会自动取消所有相关的企业微信日程
 * @param params 包含shift_id的请求参数
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function deleteShiftSchedule(
  params: OA.DeleteShiftScheduleParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>('/api/v1/wechat/shift/delete', {
    method: 'DELETE',
    params,
    ...(options || {}),
  });
}

/**
 * 获取排班详情
 * @description 根据排班ID获取详细信息
 * @param params 包含shift_id的请求参数
 * @returns Promise<OA.ApiResponse<OA.ShiftSchedule>>
 */
export async function getShiftScheduleDetail(
  params: OA.GetShiftScheduleDetailParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.ShiftSchedule>>('/api/v1/wechat/shift/detail', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 获取排班列表
 * @description 获取所有排班记录，支持按日期范围筛选
 * @param params 可选的日期范围筛选参数
 * @returns Promise<OA.ApiResponse<OA.ShiftScheduleListData>>
 */
export async function getShiftScheduleList(
  params?: OA.GetShiftScheduleListParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<OA.ShiftScheduleListData>>('/api/v1/wechat/shift/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 发布排班
 * @description 将暂存状态的排班发布，发布时会创建企业微信日程并发送通知
 * @param params 包含shift_id的请求参数
 * @returns Promise<OA.ApiResponse<any>>
 */
export async function publishShiftSchedule(
  params: OA.PublishShiftScheduleParams,
  options?: Record<string, any>
) {
  return request<OA.ApiResponse<any>>('/api/v1/wechat/shift/publish', {
    method: 'POST',
    params,
    ...(options || {}),
  });
}

/**
 * 导出排班表
 * @description 导出指定排班的Excel文件
 * @param params 包含shift_id的请求参数
 * @returns Promise<Blob>
 */
export async function exportShiftSchedule(
  params: { shift_id: number },
  options?: Record<string, any>
) {
  return request<Blob>('/api/v1/wechat/shift/export', {
    method: 'GET',
    params,
    responseType: 'blob',
    ...(options || {}),
  });
}

